import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { getPropularTravelItinerariesApi } from '../../../../services/CmsService';
import { googleApiKey, googlePhotoUrl } from '../../../../services/CommonUrl';
import likeIcon from '../../../../assets/images/like-icon.png';
import chatIcon from '../../../../assets/images/chat-icon.png';
import starIcon from '../../../../assets/images/star-icon.png';
import noPictureAvailable from '../../../../assets/images/no-picture-available.jpg';
import { PopularItineriesPlaceholder } from '../../../../components/skeleton-placeholder';
import { findCountryCity } from '../../../../helpers';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { NoDataFound } from '../../../../components/no-data-found';

const ptiItemSliderOptions = {
    loop: false,
    autoplay: true,
    margin: 10,
    mouseDrag: true,
    touchDrag: true,
    responsiveClass: true,
    navText: ["", ""],
    responsive: {
        0: {
            items: 1,
            nav: false,
            dots: true
        },
        380: {
            items: 2,
            nav: false,
            dots: true
        },
        768: {
            items: 3,
            nav: false,
            dots: true
        },
        1024: {
            items: 4,
            nav: false,
            dots: false,
            margin: 16
        }
    }
}

const PopularTravelItineraries = () => {
    const history = useHistory();
    const photoUrl = `${googlePhotoUrl}`;
    const apikey = `&key=${googleApiKey}`;
    const [popularTravelData, setPopularTravelData] = useState([]);
    const [isPtLoading, setIsPtLoading] = useState(false);

    const getAllPropularTravelData = async () => {
        setIsPtLoading(true);
        await getPropularTravelItinerariesApi(null, async (res) => {
            setIsPtLoading(false);
            // console.log("res getPropularTravelItinerariesApi ====", res);
            if (res.status === 200) {
                if (res?.data?.success) {
                    setPopularTravelData(res.data.data);
                }
            } else {
                console.log(`Error: ${res.data?.message || "An unexpected error occurred."}`);
            }
        });
    }

    useEffect(() => {
        getAllPropularTravelData();
    }, []);

    return (
        <>
            <div className="header-title-wrapper margin-bottom-60">
                <div className="head-title">
                    <h5>Recommended for you</h5>
                    <h2>Popular Travel Itineraries</h2>
                </div>
                {/* <Link to="/" className="btn-view-all">View All</Link> */}
            </div>

            {isPtLoading ?
                (
                    <OwlCarousel key={isPtLoading} {...ptiItemSliderOptions} className="owl-carousel owl-theme custom-owl-theme pt-carousel">
                        {Array.from({ length: 4 }, (_, index) => (
                            <PopularItineriesPlaceholder key={index} />
                        ))}
                    </OwlCarousel>
                ) : (
                    popularTravelData?.length > 0 ?
                        <OwlCarousel key={isPtLoading} {...ptiItemSliderOptions} className="owl-carousel owl-theme custom-owl-theme pt-carousel">
                            {popularTravelData?.map((item) => {
                                return (
                                    <>
                                        <div key={item._id} className="pti-item-box">
                                            {Array.isArray(item?.photo_reference) && item?.photo_reference.length > 0 ? (
                                                item?.photo_reference.map((photo, index) =>
                                                    index === 0 ? (
                                                        <div key={index}
                                                            className="pti-item-img"
                                                            style={{ backgroundImage: `url(${photoUrl}maxwidth=400&photoreference=${photo}${apikey})` }}>
                                                        </div>
                                                    ) : null
                                                )
                                            ) : (
                                                <div className="pti-item-img"
                                                    style={{ backgroundImage: `url(${noPictureAvailable})` }}>
                                                </div>
                                            )}
                                            <div className="pti-item-info">
                                                <div>
                                                    <p className="tdf-trip-coutry">
                                                        {item?.tour_name}
                                                    </p>
                                                    <p className="tdf-trip-days">
                                                        <span><i className="bi bi-calendar4"></i> {item.destinationCityDetails?.reduce((accumulator, current) => accumulator + current.itineraryDatys.length, 0)} Days</span>
                                                        <span>
                                                            <i className="bi bi-geo-alt"></i>&nbsp;
                                                            <OverlayTrigger
                                                                placement="top"
                                                                overlay={
                                                                    <Tooltip>
                                                                        <ul className='tdf-cc-list'>
                                                                            {item?.destinationCityDetails &&
                                                                                findCountryCity(item?.destinationCityDetails).map((ditem, index) => (
                                                                                    <li key={index}>{ditem.country}</li>
                                                                                ))}
                                                                        </ul>
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <span>{findCountryCity(item?.destinationCityDetails).length} countries,</span>
                                                            </OverlayTrigger>
                                                            <OverlayTrigger
                                                                placement="top"
                                                                overlay={
                                                                    <Tooltip>
                                                                        <ul className='tdf-cc-list'>
                                                                            {item?.destinationCityDetails &&
                                                                                findCountryCity(item?.destinationCityDetails).map((ditem) => (
                                                                                    ditem.cities.map((city, index) => (
                                                                                        <li key={index}>{city}</li>
                                                                                    ))
                                                                                ))}
                                                                        </ul>
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <span className='ms-0'>{findCountryCity(item?.destinationCityDetails).reduce((sum, item) => sum + item.cities.length, 0)} cities</span>
                                                            </OverlayTrigger>
                                                        </span>
                                                    </p>
                                                </div>
                                                <div className="tdf-social-icons">
                                                    <div className="tdf-social-icon-item">
                                                        <img width="15" src={likeIcon} className="tdf-like-icon" alt="Like icon" />{item.total_like}
                                                    </div>
                                                    <div className="tdf-social-icon-item">
                                                        <img width="20" src={chatIcon} className="tdf-comment-icon" alt="Comment icon" />{item.total_comment}
                                                    </div>
                                                    <div className="tdf-social-icon-item">
                                                        <img width="15" src={starIcon} className="tdf-rating-icon" alt="Rating icon" />{Number((item.avg_rating).toFixed(1))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )
                            })}
                        </OwlCarousel>
                        :
                        <NoDataFound text="No itinerary found" />
                )
            }
        </>
    );
};

export default PopularTravelItineraries;